var _defs, _rect, _rect2, _circle, _circle2, _circle3, _polyline, _rect3, _polyline2, _rect4, _polyline3, _line, _line2, _line3, _polyline4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLabel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 903.02 130.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#17ff39;}.c{fill:#f8ff2e;}.d{fill:#f70006;}.e,.f,.g{fill:none;stroke:#000;stroke-linejoin:round;stroke-width:7px;}.e,.g{stroke-linecap:round;}.g{opacity:0.7;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo label") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 152.71,
    height: 130.89,
    rx: 15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 12.94,
    y: 20.01,
    width: 126.82,
    height: 97.86,
    rx: 7.44
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 48.11,
    cy: 10.69,
    r: 5.03
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 33.06,
    cy: 10.69,
    r: 5.03
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 18.01,
    cy: 10.69,
    r: 5.03
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "99.58 60.7 82.09 60.7 82.09 69.45 99.58 69.45 99.58 78.19 82.09 78.19"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 53.26,
    y: 60.7,
    width: 17.49,
    height: 17.49
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "24.63 78.19 24.63 60.7 42.12 60.7 42.12 78.19"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 111.1,
    y: 32.15,
    width: 17.49,
    height: 17.49
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "82.09 49.64 82.09 32.15 99.58 32.15"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 70.89,
    y1: 32.15,
    x2: 70.89,
    y2: 49.64
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 53.4,
    y1: 49.64,
    x2: 53.4,
    y2: 32.15
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 70.89,
    y1: 40.9,
    x2: 53.4,
    y2: 40.9
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "42.12 49.64 24.63 49.64 24.63 32.15 42.12 32.15"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 111.1,
    y: 60.7,
    width: 17.49,
    height: 17.49
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 53.33,
    y: 60.7,
    width: 17.49,
    height: 17.49
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 24.63,
    y: 89.25,
    width: 17.49,
    height: 17.49
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 82.09,
    y: 89.25,
    width: 17.49,
    height: 17.49
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 53.33,
    y: 89.25,
    width: 17.49,
    height: 17.49
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.45,97.24a27.76,27.76,0,0,1-10.33,9.94A28.51,28.51,0,0,1,238,110.82H203.37a30.14,30.14,0,0,1-14.17-3.38,26.56,26.56,0,0,1-10.34-9.36A24.23,24.23,0,0,1,175,84.69V50.89a24.26,24.26,0,0,1,3.83-13.39,26.72,26.72,0,0,1,10.34-9.36,30.26,30.26,0,0,1,14.17-3.38H238a30.59,30.59,0,0,1,14.3,3.38,26.31,26.31,0,0,1,10.27,9.36,24.62,24.62,0,0,1,3.77,13.39v3.38a6.32,6.32,0,0,1-1.89,4.55,6.17,6.17,0,0,1-4.61,2h-9.36a6.19,6.19,0,0,1-4.62-2,6.31,6.31,0,0,1-1.88-4.55V51.93a7.34,7.34,0,0,0-1.82-5.2A5.56,5.56,0,0,0,238,44.78H203.37a5.49,5.49,0,0,0-4.16,2,7.32,7.32,0,0,0-1.82,5.13V83.52a7.57,7.57,0,0,0,1.82,5.2,5.4,5.4,0,0,0,4.16,2.08H238a5.42,5.42,0,0,0,4.16-2.08,7.62,7.62,0,0,0,1.82-5.2V80.66a6.44,6.44,0,0,1,6.5-6.5h9.36a6.45,6.45,0,0,1,6.5,6.5v2.86A25.89,25.89,0,0,1,262.45,97.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M371.52,109.13a6,6,0,0,1-4.35,1.69H356.9a6,6,0,0,1-4.36-1.69,5.53,5.53,0,0,1-1.75-4.16V69.22A7.37,7.37,0,0,0,349,64.09a5.51,5.51,0,0,0-4.16-2H304.38V105a5.54,5.54,0,0,1-1.76,4.16,6,6,0,0,1-4.35,1.69H288a6,6,0,0,1-4.36-1.69,5.53,5.53,0,0,1-1.75-4.16V30.61a5.56,5.56,0,0,1,1.75-4.16A6.06,6.06,0,0,1,288,24.76h10.27a6.05,6.05,0,0,1,4.35,1.69,5.57,5.57,0,0,1,1.76,4.16V42.05h40.43A29,29,0,0,1,359,45.69a27.82,27.82,0,0,1,10.4,9.88,25.55,25.55,0,0,1,3.84,13.65V105A5.54,5.54,0,0,1,371.52,109.13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M478.51,69.87a6,6,0,0,1-4.36,1.69H463.88a6,6,0,0,1-4.35-1.69,5.54,5.54,0,0,1-1.76-4.16V51.93A7.32,7.32,0,0,0,456,46.8a5.49,5.49,0,0,0-4.16-2H417.34a5.51,5.51,0,0,0-4.16,2,7.37,7.37,0,0,0-1.82,5.13v53a5.53,5.53,0,0,1-1.75,4.16,6,6,0,0,1-4.36,1.69H395a6,6,0,0,1-4.35-1.69,5.54,5.54,0,0,1-1.76-4.16v-53a25.55,25.55,0,0,1,3.84-13.65A27.92,27.92,0,0,1,403,28.4a28.86,28.86,0,0,1,14.3-3.64h34.45A29,29,0,0,1,466,28.4a27.89,27.89,0,0,1,10.4,9.88,25.63,25.63,0,0,1,3.83,13.65V65.71A5.53,5.53,0,0,1,478.51,69.87Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M576.92,97.3a27.82,27.82,0,0,1-10.4,9.88,28.88,28.88,0,0,1-14.24,3.64H517.83a28.72,28.72,0,0,1-14.3-3.64A27.84,27.84,0,0,1,493.2,97.3a25.55,25.55,0,0,1-3.84-13.65v-32a25.33,25.33,0,0,1,3.84-13.52,27.19,27.19,0,0,1,10.4-9.81,29.3,29.3,0,0,1,14.23-3.58h34.45a29.37,29.37,0,0,1,14.24,3.58,27.33,27.33,0,0,1,10.4,9.81,25.41,25.41,0,0,1,3.83,13.52v32A25.63,25.63,0,0,1,576.92,97.3ZM556.44,46.8a5.49,5.49,0,0,0-4.16-2H517.83a5.51,5.51,0,0,0-4.16,2,7.37,7.37,0,0,0-1.82,5.13V83.65a7.39,7.39,0,0,0,1.82,5.14,5.5,5.5,0,0,0,4.16,2h34.45a5.48,5.48,0,0,0,4.16-2,7.39,7.39,0,0,0,1.82-5.14V51.93A7.37,7.37,0,0,0,556.44,46.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M688.59,109.13a6,6,0,0,1-4.36,1.69H674a6,6,0,0,1-4.35-1.69,5.54,5.54,0,0,1-1.76-4.16v-53A7.37,7.37,0,0,0,666,46.8a5.49,5.49,0,0,0-4.16-2H627.42a5.49,5.49,0,0,0-4.16,2,7.37,7.37,0,0,0-1.82,5.13v53a5.53,5.53,0,0,1-1.75,4.16,6,6,0,0,1-4.36,1.69H605.06a6,6,0,0,1-4.35-1.69A5.54,5.54,0,0,1,599,105v-53a25.55,25.55,0,0,1,3.84-13.65,27.75,27.75,0,0,1,10.4-9.88,28.92,28.92,0,0,1,14.23-3.64h34.45a29.37,29.37,0,0,1,14.24,3.58,27.33,27.33,0,0,1,10.4,9.81,25.41,25.41,0,0,1,3.83,13.52V105A5.53,5.53,0,0,1,688.59,109.13Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M796.1,97.3a27.77,27.77,0,0,1-10.41,9.88,28.81,28.81,0,0,1-14.23,3.64H737a28.72,28.72,0,0,1-14.3-3.64,28,28,0,0,1-10.34-9.88,25.63,25.63,0,0,1-3.83-13.65v-32a25.41,25.41,0,0,1,3.83-13.52,27.33,27.33,0,0,1,10.4-9.81A29.34,29.34,0,0,1,737,24.76h34.45a29.3,29.3,0,0,1,14.23,3.58,27.29,27.29,0,0,1,10.41,9.81,25.41,25.41,0,0,1,3.83,13.52v32A25.63,25.63,0,0,1,796.1,97.3ZM775.62,46.8a5.51,5.51,0,0,0-4.16-2H737a5.49,5.49,0,0,0-4.16,2A7.37,7.37,0,0,0,731,51.93V83.65a7.39,7.39,0,0,0,1.82,5.14,5.48,5.48,0,0,0,4.16,2h34.45a5.5,5.5,0,0,0,4.16-2,7.39,7.39,0,0,0,1.82-5.14V51.93A7.37,7.37,0,0,0,775.62,46.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M899.18,97.17a28.9,28.9,0,0,1-24.63,13.65H834.9a5.86,5.86,0,0,1-4.23-1.69,5.53,5.53,0,0,1-1.75-4.16V96.52a5.56,5.56,0,0,1,1.75-4.16,5.91,5.91,0,0,1,4.23-1.69h39.65a5.63,5.63,0,0,0,4.22-1.82A6.62,6.62,0,0,0,880.53,84a5.82,5.82,0,0,0-6-6.24H840.1a31,31,0,0,1-14.3-3.31,26.33,26.33,0,0,1-10.34-9.23,24,24,0,0,1-3.83-13.33,25.63,25.63,0,0,1,3.83-13.65A28,28,0,0,1,825.8,28.4a28.83,28.83,0,0,1,14.3-3.64h55a6.05,6.05,0,0,1,4.35,1.69,5.57,5.57,0,0,1,1.76,4.16v8.32a5.54,5.54,0,0,1-1.76,4.16,6,6,0,0,1-4.35,1.69h-55a5.83,5.83,0,0,0-4.16,1.76,6.42,6.42,0,0,0-1.82,4.87,5.79,5.79,0,0,0,6,6.24h34.45A30.59,30.59,0,0,1,888.85,61a26.85,26.85,0,0,1,10.33,9.3A23.7,23.7,0,0,1,903,83.52,25.55,25.55,0,0,1,899.18,97.17Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLabel);
export default __webpack_public_path__ + "static/media/logo_label.773a01d9.svg";
export { ForwardRef as ReactComponent };